import { Card, CardBody, Col } from "reactstrap";
import { Badges, Image } from "../../../AbstractElements";
import { BadgeIndicatorTitle } from "../../../Constants/Constants";
import { dynamicImage } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BadgeIndicatorData, BadgeIndicatorSubTitle } from "../../../Data/UiKits/Avatars";

const BadgeIndicator = () => {
  return (
    <Col xl="4" md="6" className="box-col-6">
      <Card className="height-equal">
        <CommonCardHeader title={BadgeIndicatorTitle} span={BadgeIndicatorSubTitle}/>
        <CardBody className="avatar-showcase">
          <div className="avatars badge-avatar">
            {BadgeIndicatorData.map((item, index) => (
              <div className="avatar" key={index}>
                <Image className={`${item.imageClass} rounded-circle`} src={dynamicImage(item.image)} alt="#" />
                <Badges color={item.color} className={`position-absolute rounded-circle ${item.class}`}>
                  {item.text}
                </Badges>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BadgeIndicator;
